import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialsComponent } from './socials.component';
import { SocialsRoutingModule } from './socials-routing.module';
import { SocialService } from './socials.service';
import { SharedModule } from '../shared/shared.module';
@NgModule({
  imports: [SocialsRoutingModule, CommonModule, SharedModule],
  declarations: [SocialsComponent],
  exports: [SocialsComponent],
  providers: [SocialService]
})
export class SocialsModule { }
